import React, { useState } from 'react';
import {
  Button,
  InputNumber,
  Select,
  Space,
  Flex,
  Divider,
  Checkbox,
} from 'antd';
import { NPCAction } from '../../../types';
import { ASSET_TYPE } from '@/components/scene/react-three-components/sceneAsset';
import styles from '../../../event-timeline.module.css';

interface PlayNPCActionParamsProps {
  nodeId: string;
  params: any;
  setParams: (params: any) => void;
  selectableAssets: any[];
}

const PlayNPCActionParams: React.FC<PlayNPCActionParamsProps> = ({
  nodeId,
  params,
  setParams,
  selectableAssets,
}) => {
  const [objectId, setObjectId] = useState(params.targetNpcId || '');

  const filteredNPCAssets = selectableAssets.filter(
    (asset) =>
      asset.props.asset.type === ASSET_TYPE.GLTF.OTHER &&
      asset.props.asset.isDisabledOnSceneLoad === true
  );

  function onChangeObjectId(value: string) {
    setObjectId(value);
    setParams({ ...params, targetNpcId: value });
  }

  function onSelectStopAreaPositionPoint() {
    window.dispatchEvent(
      new CustomEvent('add_position_capture_point', {
        detail: {
          nodeId,
          actionName: 'NPC Action',
          propertyName: 'New Move to Point NPC Action',
          propertyKey: 'actionParams.pointToMove',
        },
      })
    );
  }

  return (
    <div className={styles.parameterContainer}>
      <Space direction='vertical' style={{ width: '100%' }}>
        <Divider />
        <div className={styles.selectNPCType}>
          <h1 className={styles.h1Label}>Select NPC Action Type</h1>
          <Select
            value={params.actionType}
            onChange={(value) => setParams({ ...params, actionType: value })}
            style={{ width: '100%' }}
          >
            <Select.Option value={NPCAction.MOVE}>Move</Select.Option>
          </Select>
        </div>
        <div className={styles.selectNPCType}>
          <h1 className={styles.h1Label}>Select NPC in the Scene</h1>
          {filteredNPCAssets?.length > 0 ? (
            <Select
              value={objectId}
              onChange={onChangeObjectId}
              placeholder='Select NPC'
              style={{ width: '100%' }}
            >
              {filteredNPCAssets?.map((asset) => (
                <Select.Option
                  key={
                    asset.props.asset.id || asset.props.asset.ref.current?.uuid
                  }
                  value={
                    asset.props.asset.id || asset.props.asset.ref.current?.uuid
                  }
                >
                  {asset.props.asset.name}
                </Select.Option>
              ))}
            </Select>
          ) : (
            'No 3D assets added to the scene yet.'
          )}
        </div>
        <div className={styles.selectNPCType}>
          <div>
            <h1 className={styles.h1Label}>Force Action</h1>
            <span>
              Force action will stop and CANCEL all actions that NPC doing
              currently or going to do and immediately starts this action.
            </span>
          </div>
          <Checkbox
            defaultChecked={!!params.isForced}
            value={params.isForced}
            onChange={(e) =>
              setParams({ ...params, isForced: e.target.checked })
            }
          />
        </div>
        <Divider />
        {params.actionType === NPCAction.MOVE && (
          <Space direction='vertical' style={{ width: '100%' }}>
            <h1 className={styles.h1Label}>
              <span className={styles.buttonLabel}>Move to Point</span>
              <Button
                className={styles.selectPosButton}
                onClick={onSelectStopAreaPositionPoint}
              >
                Select Point
              </Button>
            </h1>
            <Flex gap={8}>
              <div>
                <span className={styles.label}>Position X:</span>
                <InputNumber
                  value={params.actionParams?.pointToMove?.x || 0}
                  onChange={(value) =>
                    setParams({
                      ...params,
                      actionParams: {
                        pointToMove: {
                          ...params.actionParams?.pointToMove,
                          x: value,
                        },
                      },
                    })
                  }
                  style={{ width: '100%' }}
                />
              </div>
              <div>
                <span className={styles.label}>Position Y:</span>
                <InputNumber
                  value={params.actionParams?.pointToMove?.y || 0}
                  onChange={(value) =>
                    setParams({
                      ...params,
                      actionParams: {
                        pointToMove: {
                          ...params.actionParams?.pointToMove,
                          y: value,
                        },
                      },
                    })
                  }
                  style={{ width: '100%' }}
                />
              </div>
              <div>
                <span className={styles.label}>Position Z:</span>
                <InputNumber
                  value={params.actionParams?.pointToMove?.z || 0}
                  onChange={(value) =>
                    setParams({
                      ...params,
                      actionParams: {
                        pointToMove: {
                          ...params.actionParams?.pointToMove,
                          z: value,
                        },
                      },
                    })
                  }
                  style={{ width: '100%' }}
                />
              </div>
            </Flex>
          </Space>
        )}
      </Space>
    </div>
  );
};

export default PlayNPCActionParams;
